@use "@fukuri-admins/ui/layout" as *;

.container {
  display: flex;
  flex-direction: column;
  gap: spacing("16");
}

.titleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  @include typography('Jp/20_W6');
  color: text("High");
}

.cardsContainer {
  display: flex;
  gap: spacing("16");
  align-items: flex-start;
}

.overallProgressCard {
  width: 280px;
  min-height: 280px;
  padding: spacing("16");
  border-radius: borderRadius("lg");
  border: 1px solid border("Tertiary");
  @include elevation("1");

  .title {
    @include typography("Jp/16_W6");
    color: text("High");
    margin-bottom: spacing("8");
  }

  .chartContainer {
    height: 216px;
    display: flex;
    align-items: center;

    .summary {
      display: flex;
      align-items: baseline;
      gap: spacing("4");
      margin-bottom: spacing("4");
    }

    .group {
      display: flex;
      align-items: baseline;
      gap: spacing("2");
    }

    .label {
      @include typography("Jp/12_W3");
      color: text("Low");
    }

    .mainCount {
      @include typography("Jp/16_W6");
      color: var(--text-primary);
    }

    .highStressCount {
      @include typography("Jp/12_W3");
      color: text("Red");
    }

    .pendingCount {
      @include typography("Jp/12_W3");
      color: text("Middle");
    }

    .separator {
      display: inline-block;
      @include typography("Jp/12_W3");
      color: text("Low");
    }

    .detail {
      @include typography("Jp/10_W3");
      color: text("Low");
    }

    .normalBar {
      fill: chart('Gray05');
    }

    .highStressBar {
      fill: chart('Red03');
    }

    .pendingBar {
      fill: background('Secondary');
    }
  }
}

.metricRadarCard {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: spacing("16");
  border-radius: borderRadius("lg");
  border: 1px solid border("Tertiary");
  min-width: 856px;
  min-height: 280px;
  overflow: visible;
  @include elevation("1");

  .title {
    @include typography("Jp/16_W6");
    color: text("High");
  }

  .chartsContainer {
    display: flex;
    overflow-x: auto;
    overflow-y: visible;
    justify-content: space-evenly;
    align-items: center;
  }
}

.radarChartContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 274px;
  flex-shrink: 0;

  svg {
    overflow: visible;
  }

  .radarGrid {
    stroke: chart("Gray02");
  }

  .radarChart {
    fill: chart('Teal_Alpha20');
    stroke: chart('Teal05');
  }

  .radarDot {
    fill: chart('Teal05');
    r: 2;
    stroke: #fff;
  }

  .radarLabel {
    @include typography("Jp/10_W3");
    fill: text("Middle");
  }

  .chartTitle {
    @include typography("Jp/12_W3");
    display: inline-block;
    color: text("High");
    padding: spacing("6") spacing("8");
    background-color: background("Secondary");
    border-radius: borderRadius("lg");
  }
}
